import { createContext, useContext, useState, useCallback } from "react";

const Ctx = createContext(null);

export function UniversalIntakeProvider({ children }) {
  const [state, setState] = useState({ open: false, clientId: "", leadId: "" });
  const openIntake = useCallback((opts = {}) => {
    setState({ open: true, clientId: opts.clientId || "", leadId: opts.leadId || "" });
  }, []);
  const closeIntake = useCallback(() => setState((s) => ({ ...s, open: false })), []);
  return <Ctx.Provider value={{ ...state, openIntake, closeIntake }}>{children}</Ctx.Provider>;
}

export function useUniversalIntake() {
  return useContext(Ctx);
}
